import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { colors, fonts, glyphs } from "../../../Styles";
import { NumberDisplayList, UNIT, EsfStationMCore, EsfStationSizes } from "../..";
import { EsfLocation } from "../../../Services/Agrisys_GqlDataCaller/WalkThroughDataCalls/getEsfStructureCall";
import NewButton from "../../BaseComponents/newButton";

// TODO: testdata


// stations number background: 
const stationNumberSvg = (
  <svg width="80px" height="80px" viewBox="0 0 100 100">
    <g transform="rotate(-90, 50, 50)">
      <path  d="M100,100 L0,100 A100,100 0 0 1 100,0 Z" fill={colors.greyPrimary} />
    </g>
  </svg>
)

// Seperator Line
const seperatorLine = (
  <div style={{width: "320px", display: "flex", alignItems: "center", justifyContent: "center"}}>
    <div style={{width: "280px", height: "2px", backgroundColor: colors.greySecondary}}/>
  </div>
);

interface StationCard_Props {
  station: EsfLocation
  onClick: () => void 
}

export default function StationCard({station, onClick}:StationCard_Props) {
  const { t } = useTranslation()
  const [isSelected, setIsSelected] = useState(false);
  const textRefMotor = useRef<HTMLParagraphElement>(null);
  const textRefGate = useRef<HTMLParagraphElement>(null);
  const [feedMotorLength, setFeedMotorLength] = useState(100); // default fallback
  const [feedGateLength, setFeedGateLength] = useState(100); // default fallback

  useEffect(() => {
    if (textRefMotor.current) {
      const width = textRefMotor.current.offsetWidth;
      setFeedMotorLength(width);
    }
    if (textRefGate.current) {
      const width = textRefGate.current.offsetWidth;
      setFeedGateLength(width);
    }
  }, []);

  // NumberDisplayList: Currently in this section TODO
  const FeedCorrections: JSX.Element = useMemo(() => {
    return (
      <NumberDisplayList
        units={[
          <UNIT content={"Kg"} color={colors.greyTertiary} glyph={<glyphs.Kg size="15px" fillColor={colors.greyTertiary}/>}/>,
          <UNIT content={"Times"} color={colors.greyTertiary}/>
        ]}
        values={[
          0,
          0
        ]}
        headers={["fed today", "uses today"]}
        height="fit-content"
        gridTemplate="'1fr 1fr'"
        headersColor={colors.greyTertiary}
        valuesColor={colors.greyLightTertiary}
      />
    )
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t])

  // On pen click
  const handleClick = () => {
    setIsSelected((prev) => !prev);
    onClick();
  };

  return (
    <div style={{border: "5px solid "+colors.greyPrimary, borderRadius: "10px", width: "fit-content", height: "fit-content", display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gridTemplateRows: "1fr", overflow: "hidden", boxSizing: "border-box"}}>
      <div style={{gridArea: "1/1/2/2", backgroundColor: colors.greyPrimary, height: "240px", display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "1fr 92px"}}>
        <div style={{ gridArea: "1/1/2/2", display: "flex", alignItems: "center", justifyContent: "center" }}>{FeedCorrections}</div>
        <div style={{ gridArea: "2/1/3/2", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", paddingBottom: "20px" }}>
          {seperatorLine} 
          <NewButton content={"View station"} onClick={handleClick}/>
        </div>
      </div>
      <div style={{ gridArea: "1/2/2/3", backgroundColor: colors.greyLightTertiary, position: "relative", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        
        {/* Station Model */}
        <EsfStationMCore size={EsfStationSizes.small} pins={{ }} />
        {/* <div ref={textRefMotor} style={{ position: "absolute", top: "62px", left: "74px" }}><p style={{ ...fonts.header, ...fonts.fontSize3, color: colors.greyDarkPrimary }}>Feed Motor:</p></div>
        <div ref={textRefGate} style={{position: "absolute", top: "126px", left: "191px"}}><p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyDarkPrimary}}>Feed Gate:</p></div> */}
        {/* <EsfStationModel/> */}
        
        {/* Station Number */}
        <div style={{ position: "absolute", top: "0", right: "0", zIndex: "1" }}>
          {stationNumberSvg}
        </div>
        <div style={{ position: "absolute", top: "0", right: "5px", zIndex: "2", height: "60px", width: "fit-content", display: "flex", flexDirection: "column", alignItems: "end", justifyContent: "center", gap: "3px" }}>
          <p style={{ ...fonts.header, ...fonts.fontSize4, color: colors.greyTertiary }}>Station</p>  
          <p style={{ ...fonts.header, ...fonts.fontSize1, color: colors.greyLightTertiary }}>{station.name}</p>
        </div>

      </div>
    </div>
  )
}